import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ConfigService } from '../config.service';

export interface TeamSummary {
  id: string;
  name: string;
  userCount?: number;
  /** System-protected teams (e.g. Participant) cannot be deleted. */
  isDeletable?: boolean;
}

export interface TeamMember {
  id: string;
  name: string;
  email?: string;
}

@Injectable({ providedIn: 'root' })
export class TeamsService {
  private readonly baseUrl: string;

  constructor(
    private readonly http: HttpClient,
    private readonly configService: ConfigService,
  ) {
    this.baseUrl = `${this.configService.getApiUrl()}/v1/teams`;
  }

  /** Get all teams (id + name). */
  getAll(): Observable<TeamSummary[]> {
    return this.http.get<TeamSummary[]>(this.baseUrl);
  }

  /** Get all users belonging to a specific team. */
  getMembersByTeam(teamId: string): Observable<TeamMember[]> {
    return this.http.get<TeamMember[]>(`${this.baseUrl}/${teamId}/users`);
  }
}
